import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    },
    {
      name: "Table Name",
      key: "table_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "20rem",
      spanMax: "1fr",
    },
    {
      name: "DB Name",
      key: "db_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    },
    {
      name: "Account Name",
      key: "account_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    },
    {
      name: "Detected At",
      key: "detected_at",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "10rem",
    },
  ],
};
